import { Url } from '../../types';
import { neighborsResponseSchema } from './neighbors.schema';

export type Neighbor = {
  annotationUrl: Url | null;
  pageNumber: number;
  similarity: number;
};

export type NeighborsPage = {
  pageNumber: number;
  neighbors: Neighbor[];
};

export type NeighborsResponse = {
  pages: NeighborsPage[];
};

export const neighbors = (annotationId: number) => {
  return {
    endpoint: `/annotations/${annotationId}/neighbors`,
    method: 'GET',
    responseSchema: neighborsResponseSchema,
  } as const;
};
